import { Injectable } from '@angular/core';
import { ToastController } from 'ionic-angular';
import { HttpClient } from '@angular/common/http';
import { DatePipe } from '@angular/common';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/take';
import 'rxjs/add/operator/first';
import 'rxjs/add/operator/map';

import { Observable } from 'rxjs/Observable';
import { AlertController } from 'ionic-angular';

import { ConfigService } from '../../providers/dbservice/configservice';
import { Member } from '../../models/interfaces/member.model';
import { Committee } from '../../models/interfaces/committee.model';
import { CommitteeMember } from '../../models/interfaces/committee.model';
import { AuthService } from './authservice';
import { Hareline } from '../../models/interfaces/hareline.model';
import { HarelineRating } from '../../models/interfaces/hareline.model';
import { Pledge } from '../../models/interfaces/pledge.model';
import { Attendance } from '../../models/interfaces/attendance.model';


@Injectable()
export class DbserviceProvider {
  currentUser: Member;
  mPhototo = [];
  controllerBaseURI;
  public items: Array<any> = [];

  constructor(private datePipe: DatePipe,public authService: AuthService, private toastCtrl: ToastController,
    private configService: ConfigService,
    public http: HttpClient, public alertCtrl: AlertController) {

    console.log('DbserviceProvider constructor');
    this.controllerBaseURI = configService.getConfig('CONTROLLER_URL');
    if (this.authService.currentUser) {
      this.authService.currentUser.subscribe(
        user => {
          this.currentUser = user;
        }
      )
    }
  }

  dbCol(options): Observable<any> {

    if (options.action === "select") {
      return this.http.post(this.controllerBaseURI, options)
        .map(data => {
          if (data['status'] !== '0') {
          }
          else {
            return data['data'];
          }
        });
      ;
    }
    else {
      if (options.action === "insert") {

        //options.created_at= new Date();
        options.created_at = this.datePipe.transform(new Date(),'yyyy-MM-dd') ;
        //console.error("options.created_at",this.datePipe.transform(new Date(),'yyyy-MM-dd'));

        this.authService.currentUser.take(1).subscribe(
          user => {
            options.created_by = user.mb_id;
          });
      }
      else if (options.action === "update") {
        options.updated_at = new Date();
        options.updated_by = (<any>this.authService.currentUser).mb_hashname;
      }
      return this.http.post(this.controllerBaseURI, options).map(data => {
        if (data['status'] !== '0') {
        }
        else {
          // this.sendNotificationAlert(options.mapObject + " " + options.action + " success", false);
        }
        return data;
      });
    }
  }

  hasAccess(privilege: string): boolean {

    if (this.authService.privs === undefined || this.authService.privs.length === 0) {
      return false;
    }
    else {
      return this.authService.privs.indexOf(privilege) > -1 || (this.authService.privs.indexOf(privilege) === -1 ? false : true);
    }
  }
 
 

  sendNotification(message: string): void {
    let notification = this.toastCtrl.create({
      message: message,
      duration: 3000
    });
    notification.present();
  }

  sendNotificationAlert(message: string, alertWindow: boolean): void {

    if (alertWindow) {
      let alert = this.alertCtrl.create({
        subTitle: message,
        buttons: ['OK']
      });
      alert.present();
    }
    else {
      let notification = this.toastCtrl.create({
        message: message,
        duration: 3000
      });
      notification.present();
    }
  }

}



// WEBPACK FOOTER //
// ./src/providers/dbservice/dbservice.ts